module.exports = __webpack_public_path__ + "141017be97df1ecb00c59bac4ca4385a.png";